"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverallAssessmentScoreCriteriaItems = void 0;
exports.OverallAssessmentScoreCriteriaItems = ["accuracy", "fluency", "range", "coherence"];
